// Schema.org para SEO e dados estruturados
export const getSchemaData = () => {
  return {
    "@context": "https://schema.org",
    "@type": "LegalService",
    "name": "Luara Rezende Advocacia",
    "description": "Atendimento humano e estratégico para trabalhadores. Sem juridiquês.",
    "url": "https://luaraadvocacia.com.br",
    "logo": "https://luaraadvocacia.com.br/logo.png",
    "image": "https://luaraadvocacia.com.br/og-image.jpg",
    "telephone": "+55-11-99999-9999",
    "email": "contato@luaraadvocacia.com.br",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Jundiaí",
      "addressRegion": "SP",
      "addressCountry": "BR"
    },
    "areaServed": {
      "@type": "City",
      "name": "Jundiaí"
    },
    "serviceType": "Advocacia Trabalhista",
    "provider": {
      "@type": "Person",
      "name": "Luara Rezende",
      "jobTitle": "Advogada Trabalhista",
      "description": "Advogada especializada em Direito do Trabalho para pessoas físicas"
    },
    "sameAs": [
      "https://www.linkedin.com/in/luara-rezende",
      "https://www.instagram.com/luaraadvocacia"
    ],
    "openingHours": "Mo-Fr 09:00-18:00",
    "priceRange": "$$",
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "5.0",
      "reviewCount": "10"
    }
  };
};

export const getFAQSchema = () => {
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "Entrar com processo me 'queima' no mercado?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Direitos trabalhistas são garantidos por lei. Meu papel é orientar com clareza e respeito para que você decida com segurança. Casos não são divulgados e o procedimento é sigiloso."
        }
      },
      {
        "@type": "Question",
        "name": "Quanto tempo leva?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Varia conforme documentos, provas e agenda do Judiciário. No primeiro contato, explico os prazos médios e o que depende de nós."
        }
      },
      {
        "@type": "Question",
        "name": "Preciso de todos os documentos logo de cara?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Não. Na consulta eu oriento o que é essencial e o que podemos buscar depois (contrato, holerites, registros de ponto, conversas etc.)."
        }
      },
      {
        "@type": "Question",
        "name": "É possível acordo?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Sim. Muitas vezes o acordo é a solução mais rápida e eficaz. Mesmo assim, ele só acontece se fizer sentido para você."
        }
      },
      {
        "@type": "Question",
        "name": "Como são os honorários?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Explico no início, por escrito, conforme a tabela da OAB e a complexidade do caso. Sem surpresas."
        }
      },
      {
        "@type": "Question",
        "name": "Atende empresas?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Meu foco são trabalhadores (pessoas físicas). Para outros casos, posso indicar parceiros."
        }
      },
      {
        "@type": "Question",
        "name": "Atende online?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Sim. Atendo por vídeo/telefone para todo o Brasil, mantendo a mesma qualidade do atendimento presencial."
        }
      }
    ]
  };
};
